var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mainContentDiv',[_c('div',{staticClass:"w-50 pl-5 pt-5 mt-30 mb-40 mx-40"},[_c('inputCenter',{ref:"inputCenter",attrs:{"initOptions":_vm.initOptions_inputCenter}}),_c('comBtn',{staticClass:"mr-20",attrs:{"color":"deepBlue"},on:{"click":function($event){return _vm.handleSaveData()}}},[_vm._v("保存")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }